// extracted by css-extract-rspack-plugin
export default {"tabs":"CampaignsTabsPanel-module__tabs--UYTLK"};